import { TranslateService } from '@ngx-translate/core'
import { Router } from '@angular/router'
import { ConstantsService } from './constants.service'
import { map } from 'rxjs/operators'
import { apis } from '../../environments/environment'
import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable, BehaviorSubject, Subject } from 'rxjs'
import { User } from '../models/user'

@Injectable({
    providedIn: 'root'
})
export class ApiService {
    baseUrl: string
    userLoggedInSource = new BehaviorSubject(false)
    public currentBranch$: BehaviorSubject<string> = new BehaviorSubject<string>('')
    public branchesList: Array<any> = []
    scrollBottom: boolean
    scrollBottomChange = new Subject<boolean>()
    userImage = new Subject<string>()
    userLoggedInObs = this.userLoggedInSource.asObservable()
    user: User

    constructor(
        public http: HttpClient,
        public cs: ConstantsService,
        private ts: TranslateService
    ) {
        this.baseUrl = apis.baseUrl + '/public'
        this.scrollBottom = false
        this.scrollBottomChange.subscribe((value) => {
            this.scrollBottom = value
        })
        if (localStorage.getItem('token')) {
            this.user = JSON.parse(localStorage.getItem('user') as '')
            this.userLoggedInSource.next(true)
        } else {
            this.userLoggedInSource.next(false)
        }
    }

    updateBranchId(branchId: string) {
        localStorage.setItem('branchId', branchId)
        this.currentBranch$.next(branchId)
    }

    toggleScrollBottom(value: boolean): void {
        this.scrollBottomChange.next(value)
    }

    login(params: any): Observable<any> {
        const url = `${this.baseUrl}/login`

        return this.http.post<any>(url, params)
            .pipe(
                map(resp => {
                    if (resp && resp.success && resp.data.token) {
                        localStorage.setItem('token', resp.data.token)
                        localStorage.setItem('user', JSON.stringify(resp.data))
                        localStorage.setItem('branchId', resp.data.branchId)
                        this.user = resp.data
                        this.branchesList = resp.data.branches
                        this.userLoggedInSource.next(true)
                        this.currentBranch$.next(resp.data.branchId)
                        console.log("this is current branch data from service login:",resp.data);
                        console.log("this is current branch id from service login:",resp.data.branchId);
                        
                    }

                    return resp
                })
            )
    }

    googleLogin(): Observable<any> {
        const url = `${this.baseUrl}/login/${'google'}`

        return this.http.get<any>(url)
            .pipe(
                map(resp => {
                    if (resp && resp.success && resp.data.token) {
                        localStorage.setItem('token', resp.data.token)
                        localStorage.setItem('user', JSON.stringify(resp.data))
                        this.user = resp.data
                        console.log(this.user)
                        this.userLoggedInSource.next(true)
                    }

                    return resp
                })
            )
    }

    register(params: any): Observable<any> {
        const url = `${this.baseUrl}/register`

        return this.http.post<any>(url, params)
            .pipe(
                map(resp => {
                    if (resp && resp.success && resp.data.token) {
                        localStorage.setItem('token', resp.data.token)
                        localStorage.setItem('user', JSON.stringify(resp.data))
                        this.user = resp.data
                        this.userLoggedInSource.next(true)
                    }

                    return resp
                })
            )
    }

    doUserRedirects(resp: any, router: Router) {
        switch (resp.data.userType) {
            case 'Admin': {
                router.navigate(['/admin/dashboard'])
                break
            }
            case 'SubAdmin': {
                router.navigate(['/sub-admin/dashboard'])
                break
            }
            case 'Instructor': {
                router.navigate(['/instructor/dashboard'])
                break
            }
            case 'CompanyOwner': {
                router.navigate(['/company/dashboard'])
                break
            }
        }
    }

    logOut(): boolean {
        localStorage.removeItem('token')
        localStorage.removeItem('user')
        this.user.id = 0
        this.userLoggedInSource.next(false)

        return true
    }

    logOutSession(): Observable<any> {
        const url = `${this.baseUrl}/logout`

        return this.http.post<any>(url, {})
    }

    checkPermissions(permissions: Array<string>): boolean {
        return true
        const checkUrserRole = this.user.userroles.findIndex(r => r.role.name === ConstantsService.USER_ROLES.ADMIN)

        if (checkUrserRole > -1) {
            return true
        }

        const index = this.user.permissions.findIndex((item: any) => permissions.indexOf(item.name) > -1)
        if (index > -1) {
            return true
        }

        return false
    }

    checkRole() {
        return true
        // const checkUrserRole = this.user.userroles.findIndex(r => r.role.name === ConstantsService.USER_ROLES.ADMIN)

        // if (checkUrserRole > -1) {
        //     return true
        // }

        // return false
    }

    checkPermission(permission: string): boolean {
        return true
        const checkUrserRole = this.user.userroles.findIndex(r => r.role.name === ConstantsService.USER_ROLES.ADMIN)

        if (checkUrserRole > -1) {
            return true
        }

        const index = this.user.permissions.findIndex((item: any) => item.name === permission)
        // console.log('asdsad',index,permission,this.user.permissions[index]);

        if (index > -1) {
            return true
        }

        return false
    }

    isAuthenticated(): boolean {
        if (localStorage.getItem('token')) {
            return true
        }

        return false
    }

    isAdmin(): boolean {
        if (this.isAuthenticated() && this.user.userType === ConstantsService.USER_ROLES.ADMIN) {
            return true
        }

        return false
    }
    isSubAdmin(): boolean {
        if (this.isAuthenticated() && this.user.userType === ConstantsService.USER_ROLES.SUBADMIN) {
            return true
        }

        return false
    }
    isInstructor(): boolean {
        if (this.isAuthenticated() && this.user.userType === ConstantsService.USER_ROLES.INSTRUCTOR) {
            return true
        }

        return false
    }
    isCompany(): boolean {
        if (this.isAuthenticated() && this.user.userType === ConstantsService.USER_ROLES.Company) {
            return true
        }

        return false
    }



    jsonToFormData(jsonObject: any, parentKey?: any, carryFormData?: FormData): FormData {

        const formData = carryFormData || new FormData()
        let index = 0

        // tslint:disable-next-line: forin
        for (const key in jsonObject) {
            if (jsonObject.hasOwnProperty(key)) {
                if (jsonObject[key] !== null && jsonObject[key] !== undefined) {
                    let propName = parentKey || key
                    if (parentKey && this.isObject(jsonObject)) {
                        propName = parentKey + '[' + key + ']'
                    }
                    if (parentKey && this.isArray(jsonObject)) {
                        propName = parentKey + '[' + index + ']'
                    }
                    if (jsonObject[key] instanceof File) {
                        formData.append(propName, jsonObject[key])
                    } else if (jsonObject[key] instanceof FileList) {
                        for (let j = 0; j < jsonObject[key].length; j++) {
                            formData.append(propName + '[' + j + ']', jsonObject[key].item(j))
                        }
                    } else if (this.isArray(jsonObject[key]) || this.isObject(jsonObject[key])) {
                        this.jsonToFormData(jsonObject[key], propName, formData)
                    } else if (typeof jsonObject[key] === 'boolean') {
                        formData.append(propName, +jsonObject[key] ? '1' : '0')
                    } else {
                        formData.append(propName, jsonObject[key])
                    }
                }
            }
            index++
        }

        return formData
    }

    isArray(val: any) {
        const toString = ({}).toString

        return toString.call(val) === '[object Array]'
    }

    isObject(val: any) {
        return !this.isArray(val) && typeof val === 'object' && !!val
    }

    checkVerificationCode(data: any): Observable<any> {
        const url = `${this.baseUrl}/verify-code`

        return this.http.post<any>(url, data)
    }

    emailVerification(data: any): Observable<any> {
        const url = `${this.baseUrl}/verify-email`

        return this.http.post<any>(url, data).
        pipe(
            map(resp => {
                if (resp && resp.success && resp.data.token) {
                    localStorage.setItem('token', resp.data.token)
                    localStorage.setItem('user', JSON.stringify(resp.data))
                    localStorage.setItem('branchId', resp.data.branchId)
                    this.user = resp.data
                    this.branchesList = resp.data.branches
                    this.userLoggedInSource.next(true)
                    this.currentBranch$.next(resp.data.branchId)
                    console.log("this is current branch data from service email-verification:",resp.data);
                    console.log("this is current branch id from service email-verification:",resp.data.branchId);
                    
                }

                return resp
            })
        )
    }


    resendVerificationCode(data: any): Observable<any> {
        const url = `${this.baseUrl}/resend-code`

        return this.http.post<any>(url, data)
    }

    checkVerifyCode(data: any): Observable<any> {
        const url = `${this.baseUrl}/verify-code`

        return this.http.post<any>(url, data)
    }

    checkResetCode(data: any): Observable<any> {
        const url = `${this.baseUrl}/verify-code`
        return this.http.post<any>(url, data)
    }


    
    resetPass(data: any): Observable<any> {
        const url = `${this.baseUrl}/reset-password`

        return this.http.post<any>(url, data)
        .pipe(
            map(resp => {
                if (resp && resp.success && resp.data.token) {
                    localStorage.setItem('token', resp.data.token)
                    localStorage.setItem('user', JSON.stringify(resp.data))
                    localStorage.setItem('branchId', resp.data.branchId)
                    this.user = resp.data
                    this.branchesList = resp.data.branches
                    this.userLoggedInSource.next(true)
                    this.currentBranch$.next(resp.data.branchId)
                }

                return resp
            })
        )
    }

    translate(key: string) {
        return this.ts.get(key)
    }

    getCurrentLang() {
        let lang = localStorage.getItem('lang')
            ? localStorage.getItem('lang')
            : this.ts.getBrowserLang()
        if (!lang) {
            lang = 'en'
        }
        return lang
    }

    changeLanguage(lang: string) {
        this.ts.currentLang = lang
        localStorage.setItem('lang', lang)
        this.ts.setDefaultLang(lang)
        this.ts.use(lang)
        location.reload()
    }

    userImageUrl(userId?: number) {
        userId = userId ? userId : -1

        return `${apis.baseUrl}/public/profile-image/${userId}`
    }
    companyBranches(params: any): Observable<any> {
        const url = `${apis.baseUrl}//company/branch/list        `

        return this.http.get<any>(url, { params })
    }
}
